import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Axios from "axios";
import { connect } from "react-redux";

import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import { url } from "../../../../config/config";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import { useStyles } from "./DetailBookCategory.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";

class DetailBookCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "",
      categoryId: this.props.match.params.categoryId,
    };
  }

  componentDidMount() {
    this.getCategory(this.state.categoryId);
  }

  getCategory = async (categoryId) => {
    const response = await Axios.get(`${url}/api/categories/${categoryId}`, {
      headers: {
        "x-auth-token": this.props.adminToken,
      },
    });
    if (response.data.length !== 0) {
      this.setState({
        category: response.data,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <AdminPageTitle title="Book Category Details" />
          <Divider />
          {this.state.category.length !== 0 ? (
            <div style={{ padding: 40 }}>
              <div style={{ fontSize: 20 }}>
                Category Name:- {this.state.category.name}
              </div>
              <div style={{ fontSize: 20 }}>Preview</div>
              <Paper
                className={classes.paper}
                style={{
                  backgroundImage: `url(${this.state.category.imageUrl})`,
                }}
              >
                <div
                  style={{
                    color: "#ffffff",
                    fontSize: 40,
                    fontWeight: "bolder",
                  }}
                >
                  Category Name
                </div>
              </Paper>
            </div>
          ) : this.state.isEmpty === true ? (
            <div style={{ fontSize: 45, fontWeight: "bold", padding: 20 }}>
              No data present in the database
            </div>
          ) : (
            <CustomLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(DetailBookCategory));
